export const spacing = {
  maxHeroContainerWidth: `
    max-width: 1440px;
    margin-left: auto;
    margin-right: auto;
  `,
  maxContainerWidth: `
    max-width: 1260px;
    margin-left: auto;
    margin-right: auto;
  `,
  pageContainerWidth: `
    @media only screen and (max-width: 960px) {
      padding: 0 20px 30px;
    }

    @media only screen and (min-width: 960px) {
      padding-left: 272px;
      padding-right: 32px;
    }
  `,
  pageSmallContainerWidth: `
  @media only screen and (max-width: 960px) {
    padding: 0 20px 30px;
  }

  @media only screen and (min-width: 960px) {
    padding-left: 372px;
    padding-right: 32px;
  }
`,
};

// 1440px grid
// 1260px grid
